export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      <div className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-5">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse-dot"></span>
              实时更新 · 全网追踪
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 font-heading leading-tight mb-3">
              吃瓜51 — 全网最热八卦爆料平台
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-heading mb-6">
              每天更新，一手吃瓜，绝不错过任何热门事件
            </p>

            <div className="text-sm md:text-base text-foreground-600 leading-relaxed mb-7 max-w-xl mx-auto lg:mx-0 space-y-3">
              <p>
                吃瓜51网是国内领先的娱乐八卦与热门事件聚合平台，覆盖娱乐圈动态、网红追踪、
                社会热点解读等多维度内容。平台7×24小时全天候监测全网热点，从顶流塌房到
                综艺争议，从网红互撕到圈内爆料，第一时间为你呈现最热、最新、最有料的吃瓜资讯。
              </p>
              <p>
                当前站内正在热议顶流塌房后续、网红情侣分手互撕以及综艺录制事故等焦点话题，
                相关讨论热度持续飙升中。
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 justify-center lg:justify-start mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">5000万+</div>
                <div className="text-xs text-foreground-500">月活跃用户</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">10万+</div>
                <div className="text-xs text-foreground-500">日均更新内容</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">7×24h</div>
                <div className="text-xs text-foreground-500">全天候追踪热点</div>
              </div>
            </div>

            <div className="flex flex-wrap gap-3 justify-center lg:justify-start">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-flashlight-line"></i>
                立即吃瓜
              </a>
              <a
                href="#app"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#app')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 font-medium rounded-lg border border-background-300/60 hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-download-line"></i>
                下载APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20bold%20conceptual%20art%20of%20a%20megaphone%20bursting%20with%20colorful%20energy%20waves%20on%20a%20dark%20stage%2C%20warm%20coral%20and%20golden%20accents%2C%20dynamic%20abstract%20composition%2C%20entertainment%20news%20vibe%2C%20cinematic%20lighting%2C%20rich%20texture%2C%20dramatic%20contrast%2C%20editorial%20style%2C%20no%20text&width=1200&height=900&seq=hero-main&orientation=portrait"
                alt="吃瓜51 - 全网最热八卦爆料平台主视觉"
                className="w-full h-auto object-cover rounded-2xl"
                width="1200"
                height="900"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent rounded-2xl"></div>
              <div className="absolute bottom-4 left-4 right-4 flex gap-2">
                <span className="px-3 py-1 text-xs font-medium bg-background-50/90 text-primary-600 rounded-full whitespace-nowrap">实时追踪</span>
                <span className="px-3 py-1 text-xs font-medium bg-background-50/90 text-accent-600 rounded-full whitespace-nowrap">独家爆料</span>
                <span className="px-3 py-1 text-xs font-medium bg-background-50/90 text-secondary-600 rounded-full whitespace-nowrap">深度分析</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}